import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog'
import { AddDocuments } from './AddDocuments'

export type DocumentUploadMode = 'add' | 'ingest'

export function documentUploadModeForTarget(
  jobState: string | undefined,
  branch?: { origin?: string; status?: string },
  branchUnavailable = false
): DocumentUploadMode {
  if (jobState === 'cancelled' || jobState === 'cancelling') return 'ingest'
  if (branchUnavailable) return 'ingest'
  if (branch && (branch.origin !== 'ingest' || branch.status !== 'active')) return 'ingest'
  return 'add'
}

export function documentUploadCopy(mode: DocumentUploadMode): {
  title: string
  description: string
} {
  if (mode === 'add') {
    return {
      title: 'Add documents',
      description: "Add files to this ingest. The agent will pick up what's new."
    }
  }
  return {
    title: 'Ingest documents',
    description: 'Upload files to start a new ingest.'
  }
}

export interface DocumentUploadDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  mode: DocumentUploadMode
  /** Existing job id for aria labels; omit for a brand-new ingest. */
  jobId?: string
  /** When set, append/reopen this job. Omit for a fresh ingest. */
  contextJobId?: string
  seedFiles?: File[] | null
  onSeedConsumed?: () => void
  transferOpen?: boolean
  onTransferOpenChange?: (open: boolean) => void
  onComplete?: () => void
}

/** Shared Add / Ingest documents modal used by Current Ingest and the full session page. */
export function DocumentUploadDialog({
  open,
  onOpenChange,
  mode,
  jobId,
  contextJobId,
  seedFiles,
  onSeedConsumed,
  transferOpen = false,
  onTransferOpenChange,
  onComplete
}: DocumentUploadDialogProps) {
  const copy = documentUploadCopy(mode)

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next && transferOpen) return
        onOpenChange(next)
      }}
    >
      <DialogContent className="overflow-x-hidden sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{copy.title}</DialogTitle>
          <DialogDescription>{copy.description}</DialogDescription>
        </DialogHeader>
        {open ? (
          <AddDocuments
            jobId={jobId}
            contextJobId={contextJobId}
            seedFiles={seedFiles}
            onSeedConsumed={onSeedConsumed}
            onTransferOpenChange={onTransferOpenChange}
            onComplete={onComplete}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  )
}
